var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SigninWithEmail'),_c('v-row',{staticClass:"mt-1"},[_c('v-col',{attrs:{"align":"center","justify":"center"}},[_c('a',[_c('h5',{staticClass:"font-weight-regular grey--text"},[_vm._v("Forgot your password?")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }